import * as React from 'react'

import Loader from 'main/components/common/Loader'
import PaymentMethodSettings from 'main/components/payment/PaymentMethodSettings'
import { Button, Strong } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../../../../common'
import { i18nKeyPrefix } from '../../../../../../i18n'

import useAppFeatureFlags from 'main/hooks/useAppFeatureFlags'

import { ICoreProps } from '../types'
import { PaymentMethodContainer } from './PaymentMethod.styles'

const PRE = `${i18nKeyPrefix}-CTA-ENROLL-STEPS-PAYMENT`

export default function PaymentMethod(props: ICoreProps) {
  const { changeStep } = props
  const { appFeatureFlagEnabled } = useAppFeatureFlags()
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const instantEnrollForCCMS2Enabled = appFeatureFlagEnabled('instant_enroll_for_ccms_2')

  const [paymentEnabled, setPaymentEnabled] = React.useState<boolean>(false)

  if (instantEnrollForCCMS2Enabled) {
    const schoolId = props.school.id

    window.location.replace(`/parents/billing/payment-methods/pre-enrollment-check/${schoolId}`)

    return (
      <PaymentMethodContainer>
        <Loader />
      </PaymentMethodContainer>
    )
  }

  return (
    <PaymentMethodContainer>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <PaymentMethodSettings mode="parent" onChange={setPaymentEnabled} />
      <Button onClick={() => changeStep()} disabled={paymentEnabled} full>
        {t(`${PRE}-BUTTON`)}
      </Button>
    </PaymentMethodContainer>
  )
}
